import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    url: '',
    category: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="contact-page">
      {/* Page Header */}
      <section className="page-header">
        <Container>
          <h1 className="page-title">Contact</h1>
          <p className="page-subtitle">ご相談の前にお読みください</p>
        </Container>
      </section>

      {/* Before Contact */}
      <section className="section-contact-before">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="before-content">
                <h3>私たちが大切にしていること</h3>
                <p>
                  PerfTechは、クライアントの事業成長に成果連動型でコミットするグロースパートナーです。
                  そのため、すべてのご相談をお受けしているわけではありません。
                </p>
                <p>
                  私たちは、「商品力の限界がマーケティングの限界である」と考えています。
                  商品やサービスそのものに力があり、それを共に伸ばしていける関係であることが、
                  お互いにとって最善の結果を生むと信じています。
                </p>
                <h4 style={{ marginTop: '2em', marginBottom: '1em', fontSize: '15px', color: 'var(--text-primary)', fontWeight: 400 }}>
                  ご相談をお受けしやすいケース
                </h4>
                <ul>
                  <li>商品やサービスの品質に自信があり、さらなる成長を目指している</li>
                  <li>集客だけでなく、事業全体の設計から見直したいと考えている</li>
                  <li>短期的な数字だけでなく、中長期的な成長基盤を築きたい</li>
                  <li>パートナーとして対等な関係で、共に考え抜く姿勢がある</li>
                </ul>
                <p style={{ marginTop: '2em', fontSize: '13px', color: 'var(--text-tertiary)' }}>
                  これらは絶対的な基準ではなく、お話を伺った上で判断させていただきます。
                  まずはお互いにとって最善かどうかを一緒に考えるところから始められればと思います。
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact Form */}
      <section className="section-contact-form">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <p style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginBottom: '2em', lineHeight: 2 }}>
                当社はオールリモート体制のため、代表電話番号を設置しておりません。<br />
                お問い合わせは下記フォームよりご連絡ください。
              </p>

              {submitted ? (
                <div style={{ textAlign: 'center', padding: '60px 0' }}>
                  <h3 style={{ fontSize: '1.4rem', fontWeight: 300, color: 'var(--text-primary)', marginBottom: '16px' }}>
                    お問い合わせありがとうございます。
                  </h3>
                  <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 2 }}>
                    内容を確認の上、担当者よりご連絡いたします。<br />
                    なお、ご相談内容によっては、お力になれない旨をお伝えする場合がございます。
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label>お名前 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required placeholder="山田 太郎" />
                  </div>
                  <div className="form-group">
                    <label>会社名 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="text" name="company" value={formData.company} onChange={handleChange} required placeholder="株式会社○○" />
                  </div>
                  <div className="form-group">
                    <label>メールアドレス <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="info@example.com" />
                  </div>
                  <div className="form-group">
                    <label>商品・サービスのWebサイトURL</label>
                    <input type="url" name="url" value={formData.url} onChange={handleChange} placeholder="https://example.com" />
                    <p style={{ fontSize: '12px', color: 'var(--text-tertiary)', marginTop: '6px' }}>
                      事前にサービス内容を把握することで、より具体的なお話が可能になります。
                    </p>
                  </div>
                  <div className="form-group">
                    <label>ご相談のカテゴリ <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <select name="category" value={formData.category} onChange={handleChange} required>
                      <option value="">選択してください</option>
                      <option value="growth-partner">グロースパートナーとしてのご相談</option>
                      <option value="owned-media">オウンドメディア構築</option>
                      <option value="rpa">RPA構築</option>
                      <option value="ai">AI導入支援</option>
                      <option value="sns">SNS運用オートメーション</option>
                      <option value="recruit">採用に関するご相談</option>
                      <option value="other">その他</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>現在の課題と、ご相談いただく背景をお聞かせください <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <textarea name="message" value={formData.message} onChange={handleChange} required placeholder={"例：\n・現在の事業規模や商品・サービスの概要\n・抱えている課題や改善したい点\n・目指している成果や目標"} />
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <button type="submit" className="btn-primary-custom">
                      送信する
                    </button>
                  </div>
                </form>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default ContactPage;
